/**
 * PURPOSE:
 * Mostrar una sección pública de bracket: MB, RA o RB.
 *
 * RESPONSIBILITIES:
 * - Encapsular título, conteos y contenedor responsive con scroll bidireccional.
 * - Evitar que la llave empuje el ancho del viewport en laptop/tablet/celular.
 * - Mantener el árbol read-only desacoplado del componente padre.
 *
 * COLLABORATORS:
 * - CategoriasKarate.jsx
 * - PublicKarateBracketTree.jsx
 * - karateBracketUtils.js
 *
 * ROUTE:
 * src/components/Software/Karate/Categorias/components/KarateBracketSection.jsx
 */

import React from "react";
import PublicKarateBracketTree from "./PublicKarateBracketTree.jsx";
import { getFinalizedCount } from "../utils/karateBracketUtils.js";

export default function KarateBracketSection({ title, subtitle, matches = [] }) {
  if (!Array.isArray(matches) || !matches.length) {
    return null;
  }

  const finalizedCount = getFinalizedCount(matches);

  return (
    <section className="karate-bracket-shell w-full min-w-0 max-w-full overflow-hidden rounded-2xl border border-slate-200 bg-white p-2 shadow-sm sm:p-4">
      <div className="mb-3 flex min-w-0 flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <div className="flex min-w-0 flex-wrap items-center gap-2">
            <h3 className="min-w-0 text-base font-black leading-tight text-slate-900 sm:text-xl">{title}</h3>
          </div>
          {subtitle && (
            <p className="mt-1 text-xs font-semibold text-slate-500 sm:text-sm">{subtitle}</p>
          )}
        </div>

        <div className="w-fit rounded-xl bg-slate-50 px-2.5 py-1.5 text-[11px] font-black text-slate-700 ring-1 ring-slate-100 sm:px-3 sm:text-sm">
          Finalizados: {finalizedCount}/{matches.length}
        </div>
      </div>

      <div className="mb-2 rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs font-bold text-blue-800 sm:hidden">
        Desliza dentro de la llave para moverte arriba, abajo, izquierda y derecha.
      </div>

      <div
        className="karate-bracket-scroll h-[68vh] w-full min-w-0 max-w-full overflow-x-auto overflow-y-auto rounded-xl border border-slate-200 bg-slate-50 p-1 shadow-inner sm:h-auto sm:max-h-[72vh] sm:p-3 lg:max-h-[76vh]"
        tabIndex={0}
        aria-label={`Llave pública ${title}. Puedes desplazarte horizontal y verticalmente.`}
      >
        <PublicKarateBracketTree allMatches={matches} />
      </div>
    </section>
  );
}
